import { motion, AnimatePresence } from 'framer-motion';
import { X, Zap } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const UpgradePlanModal = ({ isOpen, onClose, title, message }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/dashboard/settings');
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        {/* Backdrop */}
        <motion.div
          className="absolute inset-0 bg-black/50 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        />

        {/* Modal */}
        <motion.div
          className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden"
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{ type: "spring", duration: 0.5 }}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 w-8 h-8 bg-white/80 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-700 hover:bg-white transition-all"
          >
            <X className="w-5 h-5" />
          </button>

          {/* Image */}
          <div className="relative">
            <img
              src="https://customer-assets.emergentagent.com/job_stampply-rewards/artifacts/h9x9nc0d_mejora%20tu%20plan%20%20de%20stampply.png"
              alt="Mejora tu plan"
              className="w-full h-auto"
            />
          </div>

          {/* Content */}
          <div className="p-6 text-center">
            <h2 className="text-2xl font-bold text-slate-900 mb-2">
              {title || '¡Hora de crecer!'}
            </h2>
            <p className="text-slate-600 mb-6">
              {message || 'Has alcanzado el límite de tu plan actual. Mejora para desbloquear más funcionalidades.'}
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                variant="outline"
                className="flex-1"
                onClick={onClose}
              >
                Ahora no
              </Button>
              <Button
                className="flex-1 btn-primary"
                onClick={handleUpgrade}
                data-testid="upgrade-plan-btn"
              >
                <Zap className="w-5 h-5" />
                Mejorar plan
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default UpgradePlanModal;
